import { Brain, Database } from 'lucide-react';

const AGENTS = [
  { n: 1,  name: 'Supervisor',        badge: 'Critical', color: 'red' },
  { n: 2,  name: 'Domain Router',      badge: 'Critical', color: 'red' },
  { n: 3,  name: 'Profiling Ranker',   badge: 'High',     color: 'orange' },
  { n: 4,  name: 'Schema Resolver',    badge: 'Critical', color: 'red' },
  { n: 5,  name: 'Decomposer',         badge: 'Medium',   color: 'yellow' },
  { n: 6,  name: 'SQL Composer',       badge: 'Critical', color: 'red' },
  { n: 7,  name: 'Policy Enforcer',    badge: 'Critical', color: 'red' },
  { n: 8,  name: 'Query Validator',    badge: 'Critical', color: 'red' },
  { n: 9,  name: 'Executor',           badge: 'Critical', color: 'red' },
  { n: 10, name: 'Interpreter',        badge: 'Medium',   color: 'yellow' },
  { n: 11, name: 'Confidence Scorer',  badge: 'Low',      color: 'gray' },
  { n: 12, name: 'Audit Ledger',       badge: 'Low',      color: 'gray' },
];

const badgeClass = (color) => {
  if (color === 'red')    return 'bg-red-200 border border-red-300 text-black';
  if (color === 'orange') return 'bg-orange-200 border border-orange-300 text-black';
  if (color === 'yellow') return 'bg-yellow-100 border border-yellow-300 text-black';
  return 'bg-successLight border border-green-300 text-black';
};

const AgentPipeline = ({ sources }) => {
  return (
    <div className="space-y-4">
      {/* 12-Agent Pipeline card */}
      <div className="bg-white/80 backdrop-blur-sm border border-gray-200 rounded-xl shadow p-5">
        <h2 className="text-sm font-semibold text-gray-700 mb-4 flex items-center gap-2">

          12-Agent Pipeline
        </h2>
        <ol className="space-y-2">
          {AGENTS.map(({ n, name, badge, color }) => (
            <li key={n} className="flex items-center gap-2 text-xs">
              <span className="w-5 h-5 rounded-full bg-blue-100 text-primaryDark font-bold flex items-center justify-center flex-shrink-0 text-[10px]">
                {n}
              </span>
              <span className="text-gray-700 flex-1">{name}</span>
              <span className={`text-[10px] font-medium px-1.5 py-0.5 rounded w-14 text-center inline-block ${badgeClass(color)}`}>
                {badge}
              </span>
            </li>
          ))}
        </ol>
      </div>

      {/* Connected sources card */}
      {sources && sources.length > 0 && (
        <div className="bg-white/80 backdrop-blur-sm border border-gray-200 rounded-xl shadow p-5">
          <h2 className="text-sm font-semibold text-gray-700 mb-3 flex items-center gap-2">
            <Database className="h-4 w-4 text-primary" />
            Connected sources ({sources.length})
          </h2>
          <ul className="space-y-1.5">
            {sources.slice(0, 6).map(source => (
              <li key={source.id} className="flex items-center gap-2 text-xs">
                <span className={`w-2 h-2 rounded-full flex-shrink-0 ${source.status === 'connected' ? 'bg-green-500' : 'bg-gray-300'}`} />
                <span className="text-gray-700 flex-1 truncate">{source.name}</span>
                <span className="text-gray-400 text-[10px]">{source.connector}</span>
              </li>
            ))}
            {sources.length > 6 && (
              <li className="text-xs text-primary">+{sources.length - 6} more</li>
            )}
          </ul>
        </div>
      )}
    </div>
  );
};

export default AgentPipeline;
